let asicContainerType = [
  'NONE',
  'ASiC_S',
  'ASiC_E'
]

export default asicContainerType
